import { closest } from '@jotforminc/utils';

import {
  addClass, removeClass, forEach, removeAttribute
} from './utils';

class DateHandler {
  constructor(card, hasTouch, deviceType, additionalProps) {
    this.hasTouch = hasTouch;
    this.deviceType = deviceType;
    this.isMobile = deviceType === 'mobile';
    this.isDesktop = deviceType === 'desktop';
    this.card = card;
    this.additionalProps = additionalProps;
    this.isCalendarVisible = false;
    this.inputType = this.card.question.type === 'control_inline' ? 'inline' : 'date';
    if (this.inputType === 'inline') {
      this.blotId = this.additionalProps.options[0].id;
    }
    this.updateCalendarPosition = this.updateCalendarPosition.bind(this);
    this.init();
  }

  init() {
    this.calendarContainer = this.card.cardContainer.querySelector('.jfCalendar-wrapper');
    this.liteModeInput = document.getElementById(`lite_mode_${this.card.question.id}`);
    this.dateInput = this.card.cardContainer.querySelector('.jfCardDateInput');
    if (this.card.question.type === 'control_inline') {
      this.liteModeInput = this.card.cardContainer.querySelector(`#lite_mode_${this.card.question.id}-${this.blotId}`);
      this.calendarContainer = document.querySelector(`#calendar-container-${this.card.question.id}-${this.blotId}`).parentNode;
    }
    this.setCalendarVisibility(this.isCalendarVisible);
    this.setInputVisibility();
    // this.setInputType(this.inputType);
    this.bindToggleButton();
    // this.hideDefaultInputFields();
    this.bindDateInput();
    this.moveCalendarToBody();
    this.bindCalendarCloseOnDateSelect();
    if (this.isMobile) {
      addClass(this.calendarContainer, 'mobileCalendarPopup');
    }
  }

  moveCalendarToBody() {
    this.calendarContainer.parentNode.removeChild(this.calendarContainer);
    document.body.appendChild(this.calendarContainer);
    this.calendarContainer.style.position = 'fixed';
  }

  updateCalendarPosition() {
    if (!this.isMobile) {
      const rect = this.liteModeInput.getBoundingClientRect();
      this.calendarContainer.style.top = `${rect.bottom}px`;
      this.calendarContainer.style.left = `${rect.left + (rect.width / 2)}px`;
    }
  }

  setInputType(type) {
    this.inputType = type;
    const inputs = this.card.cardContainer.querySelectorAll('.jfQuestion-fields .jfField input');
    forEach(inputs, _input => {
      const input = _input;
      input.type = type;
      const fieldContainer = closest(input, '.jfField');
      addClass(fieldContainer, 'isFilled');
    });
  }

  hideDefaultInputFields() {
    const fields = this.card.cardContainer.querySelectorAll('.jfField');
    forEach(fields, p => {
      addClass(p, 'isHidden'); // eslint-disable-line
      addClass(p, 'cf-valid-hidden'); // eslint-disable-line
    });
  }

  bindDateInput() {
    if (this.dateInput) {
      this.dateInput.addEventListener('change', e => {
        this.onLiteInputChange(e.target);
      });
    }
  }

  setCalendarVisibility(isVisible) {
    this.isCalendarVisible = isVisible;
    if (isVisible) {
      removeClass(this.calendarContainer, 'isHidden');
      this.updateCalendarPosition();
    } else {
      addClass(this.calendarContainer, 'isHidden');
    }
  }

  setInputVisibility() {
    removeClass(this.liteModeInput, 'isHidden');
    removeAttribute(this.liteModeInput, 'tabindex');
    if (this.dateInput) {
      this.dateInput.style.display = 'none';
    }
  }

  bindToggleButton() {
    const toggle = (this.blotId ? this.card.cardContainer.querySelector(`#id_${this.card.question.id}-${this.blotId}`) : this.card.cardContainer).querySelector('.jfField-svgWrapper.forDate');
    if (toggle) {
      toggle.addEventListener('keypress', e => {
        if (e.keyCode === 13 || e.keyCode === 32) {
          e.preventDefault();
          e.target.click();
        }
      });
      toggle.addEventListener('click', () => {
        this.setCalendarVisibility(!this.isCalendarVisible);
      });
    }
  }

  onLiteInputChange(input) {
    const val = input.value || '';
    const [year, month, day] = val.split('-');
    const date = new Date(year, parseInt(month, 10) - 1, day, 0, 0, 0);
    if (!isNaN(date)) {
      if (this.liteModeInput) {
        if (this.liteModeInput.hasAttribute('data-format') && this.liteModeInput.hasAttribute('data-seperator')) {
          const dateFormat = this.liteModeInput.dataset.format;
          const dateSeperator = this.liteModeInput.dataset.seperator;

          if (dateFormat && dateSeperator) {
            let formattedDate;

            switch (dateFormat) {
              case 'mmddyyyy':
                formattedDate = month + dateSeperator + day + dateSeperator + year;
                break;
              case 'ddmmyyyy':
                formattedDate = day + dateSeperator + month + dateSeperator + year;
                break;
              case 'yyyymmdd':
                formattedDate = year + dateSeperator + month + dateSeperator + day;
                break;
              default:
                // eslint-disable-next-line prefer-template
                formattedDate = month + '-' + day + '-' + year;
                break;
            }

            this.liteModeInput.value = formattedDate;
            this.onCalendarSelected(val || date);
          }
        }
      } else {
        this.calendar.setDate(date || val);
        this.calendar.selectHandler(this.calendar, val);
      }
    } else if (!val) {
      this.clearDateInputs();
      this.card.validate();
    } else {
      document.getElementById(`year_${this.card.question.id}`).value = year;
      document.getElementById(`month_${this.card.question.id}`).value = month;
      document.getElementById(`day_${this.card.question.id}`).value = day;
      this.card.validate();
    }
  }

  clearDateInputs() {
    document.getElementById(`year_${this.card.question.id}`).value = '';
    document.getElementById(`month_${this.card.question.id}`).value = '';
    document.getElementById(`day_${this.card.question.id}`).value = '';
    if (this.liteModeInput) {
      this.liteModeInput.value = '';
    }
  }

  onCalendarSelected(date) {
    if (date && this.dateInput) {
      this.dateInput.value = date;
      if (this.liteModeInput) {
        this.liteModeInput.triggerEvent('blur');
      }

      if (this.dateInput.hasAttribute('data-valid-example')) {
        // Hide mask element
        this.dateInput.previousSibling.classList.add('calendarSelect');
      }
      // this.setCalendarVisibility(false);
    }
  }

  bindCalendarCloseOnDateSelect() {
    this.calendarContainer.addEventListener('click', e => {
      if (closest(e.target, 'tbody') && closest(e.target, '.jfCalendar-container') && !closest(e.target, 'td.unselectable')) {
        if (this.dateInput) {
          this.onLiteInputChange(this.dateInput);
        }
        this.setCalendarVisibility(false);
      }
    });
  }
}

export default DateHandler;
